import { render, staticRenderFns } from "./RequestChangesSection.vue?vue&type=template&id=fc3cacce&scoped=true"
import script from "./RequestChangesSection.vue?vue&type=script&lang=js"
export * from "./RequestChangesSection.vue?vue&type=script&lang=js"
import style0 from "./RequestChangesSection.vue?vue&type=style&index=0&id=fc3cacce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3cacce",
  null
  
)

export default component.exports